<template>
  <section class="content-block">
    <transition
      name="fade"
      @before-enter="showContent_Input = true"
    >
      <div
        @click="closeModal()"
        v-if="this.$store.state.isModal_InputActive == true"
        key="1"
        class="darken-bg is-flex"
      >
        <transition
          name="slide-fade"
          @after-leave="$store.state.isModal_InputActive = false"
        >
          <div
            v-if="this.showContent_Input"
            key="2"
            class="block has-white-background is-fixed"
          >
            <div class="inner-block">
              <h1 class="title">
                {{ $t("general.errors.notAllFieldsFilled") }}
              </h1>
              <h2 class="subtitle">
                {{ $t("general.errors.notAllFieldsFilledHint") }}
              </h2>
              <a
                @click="closeModal()"
                class="button is-primary"
              >{{ $t("general.button.close") }}</a>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <transition
      name="fade"
      @before-enter="showContent_Pricing = true"
    >
      <div
        @click="closeModal()"
        v-if="this.$store.state.isModal_PricingActive == true"
        key="1"
        class="darken-bg is-flex"
      >
        <transition
          name="slide-fade"
          @after-leave="$store.state.isModal_PricingActive = false"
        >
          <div
            v-if="this.showContent_Pricing"
            key="2"
            class="block has-white-background is-fixed"
          >
            <div class="inner-block is-flex">
              <h1 class="title">
                Ticketpreise
              </h1>

              <div style="width: 100%;">
                <div class="ticket select-extended is-flex">
                  <div class="select-info">
                    <h1 class="title">
                      Bergfahrt
                    </h1>
                    <p class="subtitle no-margin">
                      Dieses Ticket hat die ID mit einer Menge
                    </p>
                  </div>

                  <div class="select-pricing">
                    <h1 class="title price-info">
                      € 24,00
                    </h1>
                    <p class="subtitle no-margin">
                      inkl. 20% MwSt.
                    </p>
                  </div>
                </div>
              </div>
              <a
                @click="closeModal()"
                class="button is-primary"
              >Schliessen</a>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <transition
      name="fade"
      @before-enter="showContent_DeleteCurrentReservation = true"
    >
      <div
        @click="closeModal()"
        v-if="this.$store.state.isModal_DeleteCurrentReservationActive == true"
        key="1"
        class="darken-bg is-flex"
      >
        <transition
          name="slide-fade"
          @after-leave="$store.state.isModal_DeleteCurrentReservationActive = false"
        >
          <div
            v-if="this.showContent_DeleteCurrentReservation"
            key="2"
            class="block has-white-background is-fixed"
          >
            <div class="inner-block">
              <h1 class="title">
                {{ $t("general.label.confirmContinue") }}
              </h1>
              <h2 class="subtitle">
                {{ $t("editView.label.cancelReservationHint") }}
              </h2>
              <a
                @click="closeModal()"
                class="button"
              >{{ $t("general.button.close") }}</a>
              <a
                @click="deleteCurrentReservation()"
                class="button is-primary"
              >{{ $t("editView.button.cancelReservation") }}</a>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <transition
      name="fade"
      @before-enter="showContent_CustomMessage = true"
    >
      <div
        @click="closeModal()"
        v-if="this.$store.state.isModal_CustomMessageActive == true"
        key="1"
        class="darken-bg is-flex"
      >
        <transition
          name="slide-fade"
          @after-leave="$store.state.isModal_CustomMessageActive = false"
        >
          <div
            v-if="this.showContent_CustomMessage"
            key="2"
            class="block has-white-background is-fixed"
          >
            <div class="inner-block">
              <h1 class="title">
                {{ $store.state.customMessageModal_MessageTitle }}
              </h1>
              <h2 class="subtitle">
                {{ $store.state.customMessageModal_MessageSubTitle }}
              </h2>
              <a
                @click="closeModal()"
                class="button is-primary"
              >{{ $t("general.button.close") }}</a>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </section>
</template>

<script>

import {liveURL} from '../../api-config';
import axios from 'axios'

export default {
  name: 'Start',
  data() {
    return {
      showContent_Input: false,
      showContent_Pricing: false,
      showContent_DeleteCurrentReservation: false,
      showContent_CustomMessage: false
    }
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.showContent_Input = false
      this.showContent_Pricing = false
      this.showContent_DeleteCurrentReservation = false
      this.showContent_CustomMessage = false
      if(this.$store.state.edit_success) {
        this.$store.state.edit_success = false;
        this.$router.push('/');
      }
    },
    deleteCurrentReservation() {
      axios.put(liveURL + '/api/eventReservation/rescind', {
        reservationNr: this.$store.state.reservation_ID
      }).then(function () {
          this.$router.push('/');
        }.bind(this))
        .catch(function (error) {
          console.log('Error:', error.response)
          this.$router.push('fehler')
        }.bind(this))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.darken-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(60, 60, 60, 0.8);
  z-index: 120;

  .block {
    width: 90%;
    max-width: 500px;
    position: absolute;
    top: calc(50% - 100px);
    left: 0;
    right: 0;
    display: block;
    box-shadow: 0px 2px 4px rgba(35, 35, 35, 0.25);
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .block.has-white-background.is-fixed {
    a.button.is-primary {
      padding-right: 0;
      padding-left: 0;
    }
  }
}

@media all and (min-width: 680px) and (max-width: 800px) {
}

@media (max-width: 680px) {

}
</style>
